module.exports = __webpack_public_path__ + "img/etalometro.01a342e9.webp";